import React, { useEffect, useState, useRef } from 'react';
import Dropzone from 'react-dropzone';
import 'react-image-crop/dist/ReactCrop.css';
import { useDispatch } from 'react-redux';
import { isEmpty, cloneDeep } from 'lodash';
import { useTranslation } from 'react-i18next';
import * as action from '../../Pages/DevlopmentOrder/store/DevelopmentOrder.action';
import noImage from '../../assets/images/no-image.png';
import ImportFileModal from '../../Pages/DevlopmentOrder/DesignDetail/ImportFileModal';

import CarouselSlider from './carouselSlider';

const isInEditMode = (fromColour, image) => {
  let FP;
  if (fromColour) {
    FP = `${image.data}`;
  } else {
    FP = `${image}`;
  }
  return FP;
};

const forImage = (isEditMode, fromColour, image) => {
  let path;
  if (isEditMode) {
    path = isInEditMode(fromColour, image);
  } else path = `${image}`;
  return path;
};

const errMsgsForExtenstions = (acceptedFiles, fromDesignDetails, fromPOTemplate, setValidatedSelectedFile, t) => {
  if (isEmpty(acceptedFiles) && (fromDesignDetails || fromPOTemplate)) {
    setValidatedSelectedFile({
      extensionError: t('SUPPLIER_IMAGE.FILE_FORMAT_SIZE'),
    });
  }
};

const errMsgsForSize = (acceptedFiles, setValidatedSelectedFile, setFiles, t) => {
  if (acceptedFiles.length > 0) {
    const fileSize = (acceptedFiles[0].size / 1024 / 1024).toFixed(0);
    if (fileSize > 5) {
      setValidatedSelectedFile({
        sizeError: t('SUPPLIER_IMAGE.ATTECHMENT_FILE_SIZE'),
      });

      return false;
    }

    setValidatedSelectedFile({});
    setFiles(
      acceptedFiles.map((file) =>
        Object.assign(file, {
          preview: URL.createObjectURL(file),
        }),
      ),
    );
  }
};

const showErrMsgs = (validatedSelectedFile) => {
  return (
    Object.keys(validatedSelectedFile).length !== 0 && (
      <div className="d-flex justify-content-center align-items-center">
        <span className="text-danger">
          {validatedSelectedFile.sizeError}
          {validatedSelectedFile.extensionError}
        </span>
      </div>
    )
  );
};

function SampleImagedrope({
  onSubmit,
  image,
  isEditMode,
  acceptedFileExtenstion,
  fromColour,
  cropSize,
  fromRelace,
  fromDesignDetails,
  replaceItem,
  fromPOTemplate,
  loading,
}) {
  const { t } = useTranslation('common');
  const cropRef = useRef(null);
  const dispatch = useDispatch();
  const [isVertical, setIsVertical] = useState(true);
  const [validatedSelectedFile, setValidatedSelectedFile] = useState({});
  const [files, setFiles] = useState([]);

  const [showImportModal, setShowImportModal] = useState(false);
  const [carouselShow, setCarouselShow] = useState(false);
  const [carouselIndex, setCarouselIndex] = useState(false);
  const [cropFlag, setCropFlag] = useState(false);
  const [submit, setSubmit] = useState(false);
  const [checkFile, setCheckFile] = useState(false);

  const supplierImageCrop = 'SUPPLIER_IMAGE.CROP';
  const supplierImageDelete = 'SUPPLIER_IMAGE.DELETE';
  const IMAGE_JPEG_TYPE = 'image/jpeg';

  useEffect(() => {
    if (files.length > 0) {
      return setSubmit(true);
    }
    setSubmit(false);
    setCheckFile(false);
  }, [files]);

  useEffect(() => {
    if (replaceItem?.image) {
      const filePath = `${replaceItem?.image}`;
      // Create a mock file object with the presigned URL as preview
      const mockFile = {
        name: `replace_image_${Date.now()}.jpg`,
        preview: filePath,
        size: 0,
        type: IMAGE_JPEG_TYPE,
        lastModified: Date.now(),
        webkitRelativePath: '',
      };
      setFiles([mockFile]);
    }
  }, [replaceItem]);

  useEffect(() => {
    if (image && image !== noImage) {
      const filePath = forImage(isEditMode, fromColour, image);

      // Create a mock file object with the presigned URL as preview
      const mockFile = {
        name: `image_${Date.now()}.jpg`,
        preview: filePath,
        size: 0,
        type: IMAGE_JPEG_TYPE,
        lastModified: Date.now(),
        webkitRelativePath: '',
      };

      setFiles([mockFile]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onFileDrop = (acceptedFiles) => {
    errMsgsForExtenstions(acceptedFiles, fromDesignDetails, fromPOTemplate, setValidatedSelectedFile, t);
    errMsgsForSize(acceptedFiles, setValidatedSelectedFile, setFiles, t);
  };

  const removeImage = async (name) => {
    const array = cloneDeep(files);
    const refactoredArray = array.filter((ele) => ele.name !== name);
    setFiles([...refactoredArray]);
    onFileDrop([...refactoredArray]);
  };

  const hideImportingFile = async () => {
    setShowImportModal(false);
    await dispatch(action.clearDocOptions());
    await dispatch(action.resetModal());
  };

  const images = (selection) => {
    return selection?.image ? selection?.image : '';
  };

  const pathSection = (selection) => {
    return selection?.path ? selection?.path : images(selection);
  };

  const selectedFile = async (selection) => {
    let filePath = `${selection?.pdf ? selection.pdf : pathSection(selection)}`;
    if (selection.docType === 'Colour') {
      filePath = filePath.replace('static', '');
    }
    // Create a mock file object with the presigned URL as preview
    const mockFile = {
      name: `selected_file_${Date.now()}${selection?.pdf ? '.pdf' : '.jpg'}`,
      preview: filePath,
      size: 0,
      type: selection?.pdf ? 'application/pdf' : IMAGE_JPEG_TYPE,
      lastModified: Date.now(),
      webkitRelativePath: '',
    };

    setFiles([mockFile]);
    setSubmit(true);

    hideImportingFile();
    await dispatch(action.clearDocOptions());
    await dispatch(action.resetModal());
  };

  const checkboxHandler = () => {
    if (isVertical === true) {
      setIsVertical(false);
      setFiles([]);
    } else {
      setIsVertical(true);
      setFiles([]);
    }
  };
  const toBase64 = async (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const getCropedFile = (data) => {
    setFiles([...data]);
    setCropFlag(true);
    setSubmit(true);
  };

  const handleImageUpload = async () => {
    setCheckFile(true);
    if (submit === true) {
      if (cropFlag === false) {
        // Process files for upload - convert blob URLs to base64 but keep presigned URLs as-is
        const processedFiles = await Promise.all(
          files.map(async (row) => {
            const base64regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
            const isPresignedUrl = row.preview?.includes('amazonaws.com') || row.preview?.startsWith('https://') || row.preview?.startsWith('http://');

            if (!base64regex?.test(row.preview) && !isPresignedUrl && row.preview?.startsWith('blob:')) {
              const cropedImage = await toBase64(row);
              return { ...row, preview: cropedImage };
            }
            return row;
          }),
        );

        const data = processedFiles.map((ele) => ({
          image: ele.cropedImage ? ele.cropedImage : ele.preview,
          isVertical,
        }));
        return onSubmit(data);
      }
      const data = files.map((ele) => ({
        image: ele.cropedImage ? ele.cropedImage : ele.preview,
        isVertical,
      }));
      return onSubmit(data);
    }
    return Promise.resolve();
  };
  const carouselHandler = (i) => {
    setCarouselShow(true);
    setCarouselIndex(i);
  };
  const carouselToggle = () => {
    setCarouselShow(!carouselShow);
  };

  const secondPart = (thumbs, thumbsHorizon) => {
    return thumbs.length > 0 && isVertical === false ? (
      <div className="crop-box mt-2">
        <label className="title">{t('SUPPLIER_IMAGE.UPLOADED_IMAGE_PREVIEW')}</label>
        <div className="form-row overflow-auto-360px">{thumbsHorizon}</div>
      </div>
    ) : (
      <div className="mt-3">
        <div className="form-row">
          <div className="col-md-6">
            <div className="card custom-card min-h-200 mb-2" />
          </div>
          <div className="col-md-6">
            <div className="card custom-card min-h-200 mb-2" />
          </div>
          <div className="col-md-6">
            <div className="card custom-card min-h-200 mb-2" />
          </div>
          <div className="col-md-6">
            <div className="card custom-card min-h-200 mb-2" />
          </div>
        </div>
      </div>
    );
  };
  console.log('🚀 ~ files:', files);
  const thumbs = files.map((file, i) => {
    console.log('🚀 ~ file:', file);
    return (
      <div className="col-md-4" key={file}>
        <div className="card custom-card min-h-350 mb-2" key={file?.name}>
          <div className="text-center px-5 py-2">
            <img className="img-max-w-h-vertical" src={file?.cropedImage ? file.cropedImage : file?.preview} alt="First slide" />
          </div>
          <div className="d-flex crop-delete-action">
            <button title={t(supplierImageCrop)} type="button" className="btn" onClick={() => carouselHandler(i)} aria-label={t(supplierImageCrop)}>
              <span className="icon-crop_cut_edit_portion_remove_icon_new" />
            </button>
            {!fromRelace && (
              <button title={t(supplierImageDelete)} type="button" className="btn" onClick={() => removeImage(file?.name)} aria-label={t(supplierImageDelete)}>
                <i className="icon-delete" />
              </button>
            )}
          </div>
        </div>
      </div>
    );
  });
  const thumbsHorizon = files.map((file, i) => (
    <div className="col-md-6" key={file}>
      <div className="card custom-card min-h-200 mb-2">
        <div>
          <div key={file?.name}>
            <div className="text-center px-5 py-2">
              <img className="img-max-w-h-horizontal" src={file?.cropedImage ? file?.cropedImage : file?.preview} alt="First slide" />
            </div>
            <div className="crop-delete-action">
              <button title={t(supplierImageCrop)} type="button" className="btn" onClick={() => carouselHandler(i)} aria-label={t(supplierImageCrop)}>
                <span className="icon-crop_cut_edit_portion_remove_icon_new" />
              </button>
              {!fromRelace && (
                <button
                  title={t(supplierImageDelete)}
                  className="btn"
                  onClick={() => removeImage(file?.name)}
                  type="button"
                  aria-label={t(supplierImageDelete)}
                >
                  <i className="icon-delete" />
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  ));
  return (
    <>
      <div className="common-image-upload">
        <Dropzone accept={acceptedFileExtenstion} onDrop={onFileDrop}>
          {({ getRootProps, getInputProps, isDragActive }) => (
            <section className="upload-image-section" {...getRootProps()}>
              <div className="w-100 text-center">
                <input {...getInputProps()} />
                {isDragActive ? (
                  <p className="mb-0">{t('SUPPLIER_IMAGE.DROP_FILES_HERE')}</p>
                ) : (
                  <p className="mb-0">{t('SUPPLIER_IMAGE.DRAG_AND_DROP_FILES')}</p>
                )}
              </div>

              <label className="upload-icon ">
                <input {...getInputProps()} type="file" accept={acceptedFileExtenstion} className="img-Upload" />

                <a href={() => false} className="mt-16 align-items-center justify-content-center">
                  <span className=" icon-Upload-1" />
                </a>
              </label>
            </section>
          )}
        </Dropzone>
        {fromRelace === true ? null : (
          <div>
            <p className="mt-1">{t('SUPPLIER_IMAGE.SAMPLE_IMAGE_TYPE')}</p>
            <div className="d-flex  align-items-center">
              <p className="custom-radio mb-0 mr-2">
                <input type="radio" id="status1" name="status" value={isVertical} defaultChecked onChange={checkboxHandler} />
                <label className="m-0" htmlFor="status1">
                  {t('SUPPLIER_IMAGE.VERTICAL_IMAGE')}
                </label>
              </p>
              <p className="custom-radio mb-0 mr-2">
                <input type="radio" id="status0" name="status" value={isVertical} onChange={checkboxHandler} />
                <label className="m-0" htmlFor="status0">
                  {t('SUPPLIER_IMAGE.HORIZONTAL_IMAGE')}
                </label>
              </p>
            </div>
          </div>
        )}

        {submit === false && checkFile === true && (
          <div className="d-flex justify-content-center align-items-center">
            <span className="text-danger">{t('SUPPLIER_IMAGE.PLEASE_SELECT_FILE')}</span>
          </div>
        )}

        {showErrMsgs(validatedSelectedFile)}
        {isVertical === true ? (
          <div className="upload-crop-section mt-3">
            {thumbs.length > 0 && isVertical === true ? (
              <div className="crop-box">
                <label className="title">{t('SUPPLIER_IMAGE.UPLOADED_IMAGE_PREVIEW')}</label>
                <div className="form-row overflow-auto-360px">{thumbs}</div>
              </div>
            ) : (
              <div className="form-row">
                <div className="col-md-4">
                  <div className="card custom-card min-h-350" />
                </div>
                <div className="col-md-4">
                  <div className="card custom-card min-h-350" />
                </div>
                <div className="col-md-4">
                  <div className="card custom-card min-h-350" />
                </div>
              </div>
            )}
          </div>
        ) : (
          secondPart(thumbs, thumbsHorizon)
        )}
        <br />

        <div className="common-model-footer">
          <button onClick={handleImageUpload} type="button" disabled={loading} className="btn p-0">
            <span className="icon-Tick-1 f-24" />
          </button>
        </div>
      </div>

      {showImportModal && <ImportFileModal onOpen={showImportModal} toggle={hideImportingFile} onSubmit={selectedFile} />}
      {carouselShow && (
        <CarouselSlider
          cropRef={cropRef}
          show={carouselShow}
          toggle={carouselToggle}
          files={files}
          index={carouselIndex}
          cropSize={cropSize}
          isVertical={isVertical}
          getCropedFile={getCropedFile}
        />
      )}
    </>
  );
}
export default SampleImagedrope;
